import React from "react";
import {
  Checkbox,
  Radio,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
} from "@material-ui/core";
import CustomTextField from "../Common/CustomTextField";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { isSuperAdminLogin } from "../../utils";
const modules = ["chartering", "operations", "accounts", "agency", "shipmanagament", "admin", "riskmanagement", "fuelsupply", "knowledgepartner"];
function AddNewUser(props) {
  const {
    user = {},
    getForwardUser = "",
    setUser = () => { },
    isEdit = false,
    selectedOrganization = {},
    onChangeOrganization = () => { },
    isAdminLogin = () => { },
    allOrganization = [],
    userByOrganization = [],
    allAccess = [],
  } = props;
  let { allRoles = [] } = props;
  const {
    firstName = "",
    lastName = "",
    email = "",
    forwardEmail = "",
    dateOfBirth = "",
    premiumAccessExpiry,
    password = "",
    organizationId = "",
    role = [],
    isPremium = false,
    isVerified = false,
  } = user || {};

  const handleModuleHeadChange = (module, selectedIds) => {
    const selectedUsers = userByOrganization.filter(u => selectedIds.includes(u._id));
    const simplifiedUsers = selectedUsers.map(user => ({
      _id: user._id,
      firstName: user.firstName,
      lastName: user.lastName
    }));

    setUser(prevUser => ({
      ...prevUser,
      moduleHeads: {
        ...prevUser.moduleHeads,
        [module]: simplifiedUsers
      }
    }));
  };

  const onChange = (key, value) => {
    setUser(prevUser => {
      if (key === "role") {
        const newModuleAccess = value === "superboss" ? modules.filter(m => m !== 'knowledgepartner') : ['chartering'];
        const newModuleHeads =
          value === "head" || value === "superboss"
            ? {}
            : modules.reduce((acc, module) => {
              if (newModuleAccess.includes(module)) {
                acc[module] = [];
              }
              return acc;
            }, {});

        return {
          ...prevUser,
          role: value,
          moduleAccess: newModuleAccess,
          moduleHeads: newModuleHeads
        };
      }

      if (key === "moduleAccess") {
        const updatedModuleAccess = value;
        const updatedModuleHeads = Object.keys(prevUser.moduleHeads || {}).reduce((acc, module) => {
          if (updatedModuleAccess.includes(module)) {
            acc[module] = prevUser.moduleHeads[module];
          }
          return acc;
        }, {});

        updatedModuleAccess.forEach(module => {
          if (!updatedModuleHeads[module]) {
            updatedModuleHeads[module] = [];
          }
        });

        return {
          ...prevUser,
          moduleAccess: updatedModuleAccess,
          moduleHeads: updatedModuleHeads
        };
      }

      return {
        ...prevUser,
        [key]: value
      };
    });
  };


  return (
    <div className="admin-form grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <label htmlFor="admin-user-first-name" className="block text-[11px] text-slate-700 mb-1">First Name</label>
        <CustomTextField id="admin-user-first-name" size="small" placeholder="First name" value={firstName} onChange={(e) => onChange("firstName", e.target.value)} />
      </div>
      <div>
        <label htmlFor="admin-user-last-name" className="block text-[11px] text-slate-700 mb-1">Last Name</label>
        <CustomTextField id="admin-user-last-name" size="small" placeholder="Last name" value={lastName} onChange={(e) => onChange("lastName", e.target.value)} />
      </div>
      <div>
        <label htmlFor="admin-user-email" className="block text-[11px] text-slate-700 mb-1">Email</label>
        <CustomTextField id="admin-user-email" size="small" placeholder="Email address" value={email} disabled={isEdit} onChange={(e) => onChange("email", e.target.value)} />
      </div>
      <div>
        <label htmlFor="admin-user-forward-email" className="block text-[11px] text-slate-700 mb-1">Forward Email Address</label>
        <CustomTextField id="admin-user-forward-email" size="small" placeholder="Email address" value={forwardEmail} disabled={getForwardUser && isEdit} onChange={(e) => onChange("forwardEmail", e.target.value)} />
      </div>
      <div>
        <label htmlFor="admin-user-birth-date" className="block text-[11px] text-slate-700 mb-1">Date of Birth</label>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            id="admin-user-birth-date"
            autoComplete={isSuperAdminLogin() ? "off" : undefined}
            autoOk
            fullWidth
            size="small"
            margin="none"
            variant="inline"
            PopoverProps={{ PaperProps: { className: "compact-popover" } }}
            inputVariant="outlined"
            format="DD/MMM/yyyy"
            placeholder="DD/MMM/YYYY"
            value={dateOfBirth || null}
            InputAdornmentProps={{ position: "end" }}
            onChange={(date) => onChange("dateOfBirth", date)}
          />
        </MuiPickersUtilsProvider>
      </div>
      <div>
        <label htmlFor="admin-user-expiry-date" className="block text-[11px] text-slate-700 mb-1">Premium Access Expiry Date</label>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            id="admin-user-expiry-date"
            autoComplete={isSuperAdminLogin() ? "off" : undefined}
            autoOk
            fullWidth
            size="small"
            margin="none"
            variant="inline"
            PopoverProps={{ PaperProps: { className: "compact-popover" } }}
            inputVariant="outlined"
            format="DD/MMM/yyyy"
            placeholder="DD/MMM/YYYY"
            value={premiumAccessExpiry || null}
            InputAdornmentProps={{ position: "end" }}
            onChange={(date) => onChange("premiumAccessExpiry", date)}
          />
        </MuiPickersUtilsProvider>
      </div>
      {/* Retain the existing hidden autofill field. */}
      <div className="hidden"><CustomTextField /></div>
      {!isEdit && (
        <div className="sm:col-span-2">
          <label htmlFor="admin-user-password" className="block text-[11px] text-slate-700 mb-1">Password</label>
          <CustomTextField id="admin-user-password" size="small" inputType="password" autoComplete={isSuperAdminLogin() ? "new-password" : undefined} placeholder="Password" value={password} onChange={(e) => onChange("password", e.target.value)} />
        </div>
      )}

      <div className="sm:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-3 border-t border-slate-200 pt-3">
        {user.role !== "superadmin" && (isSuperAdminLogin() || !isEdit) && (
          <fieldset className="min-w-0">
            <legend className="text-[11px] text-slate-700 mb-1">Role</legend>
            <div className="flex flex-wrap sm:flex-col gap-1">
              {Array.isArray(allRoles) && allRoles
                .filter((item) => !item?.hide)
                .filter((item) => user?.organizationId || item.value !== "head")
                .map((item) => (
                  <label key={item.value} className="flex items-center gap-1 text-[11px] text-slate-700 cursor-pointer">
                    <Radio name="admin-user-role" size="small" checked={role === item.value} onChange={() => onChange("role", item.value)} className="p-1" />
                    {item.name}
                  </label>
                ))}
            </div>
          </fieldset>
        )}

        <div className={`min-w-0 space-y-3 ${user.role !== "superadmin" && (isSuperAdminLogin() || !isEdit) ? "sm:col-span-2" : "sm:col-span-3"}`}>
          {user.role !== "superboss" && (
            <div>
              <label id="admin-user-organization-label" className="block text-[11px] text-slate-700 mb-1">Organization</label>
              <FormControl size="small" variant="outlined" fullWidth>
                <Select
                  labelId="admin-user-organization-label"
                  value={organizationId || ""}
                  onChange={(e) => onChange("organizationId", e.target.value)}
                  disabled={isEdit && (!isAdminLogin() || !isSuperAdminLogin())}
                  displayEmpty
                  className="bg-white rounded-none text-[11px]"
                  MenuProps={{ PaperProps: { className: "admin-form-menu" } }}
                >
                  <MenuItem value="" disabled>Select organization</MenuItem>
                  {Array.isArray(allOrganization) && allOrganization.map((item) => (
                    <MenuItem key={item._id} dense value={item._id}>{item.organizationName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
          <div>
            <label id="admin-user-modules-label" className="block text-[11px] text-slate-700 mb-1">Module Access</label>
            <FormControl size="small" variant="outlined" fullWidth>
              <Select
                labelId="admin-user-modules-label"
                multiple
                value={user.moduleAccess || []}
                onChange={(e) => onChange("moduleAccess", e.target.value)}
                renderValue={(selected) => selected.join(", ")}
                className="bg-white rounded-none capitalize text-[11px]"
                MenuProps={{ PaperProps: { className: "admin-form-menu" } }}
              >
                {modules.map((module) => (
                  <MenuItem key={module} value={module} dense>
                    <Checkbox size="small" checked={user.moduleAccess?.includes(module)} color="primary" />
                    <ListItemText primary={module.charAt(0).toUpperCase() + module.slice(1)} primaryTypographyProps={{ className: "text-[11px]" }} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {user.role === "user" && user.organizationId && user.moduleAccess?.map((module) => (
            <div key={module}>
              <label id={`admin-user-head-${module}`} className="block text-[11px] text-slate-700 mb-1 capitalize">{module} Head</label>
              <FormControl size="small" variant="outlined" fullWidth>
                <Select
                  labelId={`admin-user-head-${module}`}
                  multiple
                  value={(user.moduleHeads?.[module] || []).map((u) => u._id)}
                  onChange={(e) => handleModuleHeadChange(module, e.target.value)}
                  renderValue={(selectedIds) => userByOrganization
                    .filter((u) => selectedIds.includes(u._id))
                    .map((u) => `${u.firstName} ${u.lastName}`.trim()).join(", ")}
                  className="bg-white rounded-none text-[11px]"
                  MenuProps={{ PaperProps: { className: "admin-form-menu" } }}
                >
                  {userByOrganization.length > 0 ? userByOrganization.map((item) => (
                    <MenuItem key={item._id} value={item._id} dense>
                      <Checkbox size="small" checked={(user.moduleHeads?.[module] || []).some((head) => head._id === item._id)} color="primary" />
                      <span className="text-[11px]">{item.firstName} {item.lastName}</span>
                      <span className="text-[11px] ml-1 text-slate-500 truncate" title={item.email}>({item.email})</span>
                    </MenuItem>
                  )) : (
                    <MenuItem disabled><ListItemText primary="No available users" /></MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
          ))}

          {user.role !== "superadmin" && (
            <fieldset>
              <legend className="text-[11px] text-slate-700 mb-1">User Access</legend>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                {Array.isArray(allAccess) && allAccess.map((item) => (
                  <label key={item.value} className="flex items-center gap-1 text-[11px] text-slate-700 cursor-pointer">
                    <Checkbox size="small" checked={!!user[item.value]} onChange={() => onChange(item.value, !user[item.value])} className="p-1" />
                    {item.name}
                  </label>
                ))}
              </div>
            </fieldset>
          )}
        </div>
      </div>
      {user.role === "superboss" && (
        <div className="sm:col-span-2">
          <label htmlFor="admin-user-description" className="block text-[11px] text-slate-700 mb-1">Description</label>
          <textarea id="admin-user-description" className="w-full border border-slate-300 rounded-none p-2 text-[11px] text-slate-800 resize-y focus:border-[#313C4C]" rows={2} value={user.description || ""} onChange={(e) => onChange("description", e.target.value)} placeholder="Add description" />
        </div>
      )}
    </div>
  );
}

export default AddNewUser;
